"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimateCharacterVfxStepArgs = void 0;
const uuid_1 = require("uuid");
const LocationSelector_1 = require("../LocationSelector");
class AnimateCharacterVfxStepArgs {
    constructor(key, location, speed = 1, idleAfter = key !== "killed") {
        this.key = key;
        this.location = location;
        this.speed = speed;
        this.idleAfter = idleAfter;
        this.__typeName = "AnimateCharacter";
        this.id = (0, uuid_1.v4)();
    }
}
exports.AnimateCharacterVfxStepArgs = AnimateCharacterVfxStepArgs;
AnimateCharacterVfxStepArgs.Damaged = (actorId) => new AnimateCharacterVfxStepArgs("damaged", new LocationSelector_1.ActorVfxLocationSelector(actorId));
AnimateCharacterVfxStepArgs.Healed = (actorId) => new AnimateCharacterVfxStepArgs("healed", new LocationSelector_1.ActorVfxLocationSelector(actorId));
AnimateCharacterVfxStepArgs.Killed = (actorId) => new AnimateCharacterVfxStepArgs("killed", new LocationSelector_1.ActorVfxLocationSelector(actorId));
AnimateCharacterVfxStepArgs.Attacking = (actorId) => new AnimateCharacterVfxStepArgs("attacking", new LocationSelector_1.ActorVfxLocationSelector(actorId));
AnimateCharacterVfxStepArgs.Blocked = (actorId) => new AnimateCharacterVfxStepArgs("blocked", new LocationSelector_1.ActorVfxLocationSelector(actorId));
AnimateCharacterVfxStepArgs.Resurrected = (actorId) => new AnimateCharacterVfxStepArgs("resurrected", new LocationSelector_1.ActorVfxLocationSelector(actorId));
AnimateCharacterVfxStepArgs.Idle = (actorId) => new AnimateCharacterVfxStepArgs("idle", new LocationSelector_1.ActorVfxLocationSelector(actorId));
